import type { AnalysisConfig } from './analysisConfig.ts';
import type { LeagueKey } from './league.ts';

export interface ConfigPreset {
  id: string;
  name: string;
  config: AnalysisConfig;
  /** LeagueKey this preset was created for (e.g. 'basketball_nba'). Undefined = universal. */
  league?: LeagueKey;
  createdAt: string;
  updatedAt: string;
}

export const DEFAULT_PRESET_ID = 'default';
export const MAX_CUSTOM_PRESETS = 5;
export const MAX_PRESET_NAME_LENGTH = 30;
